import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  getClinicianPatientsList,
  getCliniciansList,
  initClinicianPage,
} from "store/ClinicianStore/actions";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { Grid } from "@mui/material";
import { ClinicManagementHome } from "./components/ClinicManagementHome/ClinicManagementHome";
import { getClinicPatientsList } from "store/PatientStore/actions";
import { Clinician } from "types/Clinician";
import { formatName } from "./components/Management/common/functions";

export const ClinicAdminOverview = () => {
  const dispatch = useAppDispatch();
  const currentClinician: Clinician | undefined = useAppSelector(
    selectCurrentClinician
  );

  useEffect(() => {
    if (!currentClinician?.role?.includes(USER_GROUPS.SUPER_ADMIN)) {
      dispatch(initClinicianPage());
      dispatch(getCliniciansList());
      dispatch(getClinicPatientsList());
    }
  }, []);

  useEffect(() => {
    if (
      currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) &&
      (currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_MEMBER) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD))
    ) {
      dispatch(getClinicianPatientsList(currentClinician._id));
    }
  }, [currentClinician]);

  return (
    <div className="container max-w-[95%] m-auto px-8 pt-[40px]">
      {(currentClinician?.role?.includes(USER_GROUPS.CLINIC_ADMIN) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_MEMBER)) && (
        <>
          <h1 className="leading-10">
            <Grid container>
              <Grid>Welcome to Allheartz</Grid>
              <Grid
                style={{ fontSize: 18, fontWeight: "bold", marginLeft: 10 }}
              >
                {"| You accessed the page as " +
                  currentClinician?.role?.map(formatName).join(", ")}
              </Grid>
            </Grid>
          </h1>
          <ClinicManagementHome />
        </>
      )}
    </div>
  );
};
